module.exports = __webpack_public_path__ + "static/media/25.6a5d54c2.jpg";